import i18n from "@/lib/i18n";
import * as React from "react";
import { formatCentsAsDollars } from "@/lib/price-utils";

// Base Total Section Component
interface BaseTotalSectionProps {
  title: string;
  amountBeforeDiscount: number;
  hasDiscount?: boolean;
  className?: string;
  children?: React.ReactNode;
}

const BaseTotalSection: React.FC<BaseTotalSectionProps> = ({
  title,
  amountBeforeDiscount,
  hasDiscount = false,
  className,
  children,
}) => (
  <div
    className={`bg-slate-50 border border-slate-200 rounded-lg p-6 ${className || ""}`}
  >
    <div className="space-y-4">
      <h3 className="text-lg font-semibold text-slate-900 border-b border-slate-200 pb-2">
        {title}
      </h3>

      <div className="space-y-3">
        <div className="flex justify-between items-center">
          <span className="text-slate-600">
            {hasDiscount ? i18n.t("features.quotes.quoteViewer.sections.templateTotalSection.subtotalBeforeDiscount") : i18n.t("features.quotes.quoteViewer.sections.templateTotalSection.subtotal")}
          </span>
          <span className="font-medium text-slate-900">
            ${formatCentsAsDollars(amountBeforeDiscount)}
          </span>
        </div>

        {children}
      </div>
    </div>
  </div>
);

// Template Total Section (No Tax)
interface TemplateTotalSectionProps {
  data: {
    amountPrediscount: number;
    amountPresalesTax: number;
  };
  className?: string;
}

export const TemplateTotalSection: React.FC<TemplateTotalSectionProps> = ({
  data,
  className,
}) => (
  <BaseTotalSection
    title={i18n.t("features.quotes.quoteViewer.sections.templateTotalSection.templatePricing")}
    amountBeforeDiscount={data.amountPrediscount}
    className={className}
  >
    <div className="flex justify-between items-center bg-primary/10 p-3 rounded">
      <span className="text-lg font-semibold text-slate-900">
        {i18n.t("features.quotes.quoteViewer.sections.templateTotalSection.subtotalAfterDiscount")}
      </span>
      <span className="text-2xl font-bold text-primary">
        ${formatCentsAsDollars(data.amountPresalesTax)}
      </span>
    </div>
  </BaseTotalSection>
);
